import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

// YouTube Icon Component
const YouTubeIcon = ({ size = 24, className = '' }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    className={className}
  >
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const Footer = () => {
  const team = [
    { 
      name: 'Alexandra CHALLET', 
      phone: '06 29 65 35 24', 
      role: 'Scénariste, Réalisatrice d\'action & documentaire, 2ème équipe action, Actrice' 
    },
    { 
      name: 'André FERRER', 
      phone: '07 68 25 76 00', 
      role: 'Comédien cascadeur, Régleur cascade' 
    },
    { 
      name: 'Éric TATIN', 
      phone: '07 86 12 39 12', 
      role: 'Régleur cascade, Spécialisé câblage' 
    },
  ];

  return (
    <footer className="bg-[#09090b] border-t border-white/10">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-['Teko'] text-4xl text-[#FACC15] mb-4">STUNT DIRECTOR</h3>
            <p className="text-gray-400 font-['Barlow'] leading-relaxed">
              Cascades physiques, mécaniques auto-moto-bateau, crash, torche, 
              chute de hauteur, câblage. Réalisation en 2ème équipe action.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Teko'] text-2xl text-white mb-4 uppercase">Navigation</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-gray-400 hover:text-[#FACC15] transition-colors font-['Barlow']">Accueil</Link>
              <Link to="/gallery" className="text-gray-400 hover:text-[#FACC15] transition-colors font-['Barlow']">Galerie</Link>
              <Link to="/trainings" className="text-gray-400 hover:text-[#FACC15] transition-colors font-['Barlow']">Formations</Link>
              <Link to="/services" className="text-gray-400 hover:text-[#FACC15] transition-colors font-['Barlow']">Services</Link>
              <Link to="/documentaire" className="text-gray-400 hover:text-[#FACC15] transition-colors font-['Barlow']">Documentaire</Link>
              <Link to="/contact" className="text-gray-400 hover:text-[#FACC15] transition-colors font-['Barlow']">Contact</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Teko'] text-2xl text-white mb-4 uppercase">Contact</h4>
            <div className="flex flex-col gap-3">
              <a 
                href="mailto:contact@stuntdirector.fr" 
                className="flex items-center gap-3 text-gray-400 hover:text-[#FACC15] transition-colors font-['Barlow']"
                data-testid="footer-email"
              >
                <Mail size={18} className="text-[#FACC15]" />
                contact@stuntdirector.fr
              </a>
              {team.map((member) => (
                <a 
                  key={member.phone}
                  href={`tel:${member.phone.replace(/\s/g, '')}`} 
                  className="flex items-center gap-3 text-gray-400 hover:text-[#FACC15] transition-colors font-['Barlow'] text-sm"
                  data-testid={`footer-phone-${member.phone}`}
                >
                  <Phone size={16} className="text-[#FACC15]" />
                  {member.name}: {member.phone}
                </a>
              ))}
              
              {/* YouTube Channel */}
              <a 
                href="https://www.youtube.com/@Alexmaybeplanet" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-[#FF0000] transition-colors font-['Barlow'] mt-2"
                data-testid="footer-youtube"
              >
                <YouTubeIcon size={20} className="text-[#FF0000]" />
                Notre chaîne YouTube
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm font-['Barlow']">
            © {new Date().getFullYear()} STUNT DIRECTOR. Tous droits réservés.
          </p>
          <Link 
            to="/admin/login" 
            className="text-gray-500 hover:text-[#FACC15] text-sm font-['Barlow'] transition-colors"
            data-testid="footer-admin-link"
          >
            Administration
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
